import { ActivateFiltersButton } from '@/components/filters/activate-filters-button';
import { activeFilterTypeState } from '@/components/filters/filter.state';
import { useSetAtom } from 'jotai';

export const FilterProjectsInput = () => {
  const setActiveFilterType = useSetAtom(activeFilterTypeState);
  return (
    <ActivateFiltersButton
      data-testid="filter-button"
      variant="text"
      startIcon="FilterMD"
      onClick={() =>
        setActiveFilterType(current =>
          current === 'advanced' ? null : 'advanced',
        )
      }
    ></ActivateFiltersButton>
  );
};
